import React from 'react';
import {Grid, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {
  safeAdd,
  safeAddReduce,
  safeMult,
  showDollarAmountWithDollar,
  safeDivide,
} from 'common/utils';
import {REQUEST_DETAILS_VALUE_CHANGE_DISPLAY} from 'app-ui-componentlibrary/dist/common/constants';
import {ContentDispatch} from 'framework';
import {
  CARD_TYPES,
  COST_ITEM_PERIOD_TYPE,
  MODES,
  YEAR,
  QUANTITY,
  PRICE,
  TOTAL,
  COST,
  BOC,
  ACTUAL_PRICE,
  ACTUAL_QUANTITY,
  ACTUAL_TOTAL,
  ACTUAL_ALLOWED_TOTAL,
  ALLOWED_EXCESS_TOTAL,
  DISALLOWED_TOTAL,
  SCOPE_OF_WORK_TOTAL,
  CATEGORIZED_SUM,
  NOT_FULLY_IN_SCOPE,
  ADDITIONAL_INFORMATION,
} from 'common/requestDetails/constants';
import HeaderSection from 'go/components/modules/requestDetails/v3/items/shared/simple/HeaderSection';
import produce from 'immer';
import DynamicElement from 'go/components/modules/requestDetails/v3/items/shared/DynamicElement';
import {calculateUnitCosts, calculateActualUnitCosts} from 'common/requestDetails/utils';
export class SimpleHiringInternal extends React.Component {
  constructor(props, context) {
    super(props, context);

    const {item, period, beingCreated, itemConfig} = props;
    let costs =
      _.size(_.get(item, COST)) > period.increments
        ? _.slice(_.get(item, COST), 0, period.increments)
        : _.get(item, COST, []);
    if (_.size(costs) < period.increments) {
      costs = [...costs, ..._.times(period.increments - _.size(costs), () => [])];
    }

    if (beingCreated && itemConfig.boc && !_.isEmpty(itemConfig.boc)) {
      costs = _.map(costs, (costArray) => {
        _.forEach(itemConfig.boc, (boc) => {
          costArray.push({boc: boc});
        });
        return costArray;
      });
    }

    if (!_.isEqual(costs, _.get(item, COST))) {
      this.props
        .handleChange({
          ...item,
          cost: costs,
        })
        .then((res) => {
          this.props.handleBlur();
        });
    }
  }

  addCost = () => {
    let item = this.props.item;
    const newCost = produce(item.cost, (draft) => {
      draft[0].push({total: 0, quantity: 0, boc: '', price: ''});
    });
    this.props.handleItemChange(COST, newCost);
  };

  removeCost = (ind) => {
    let item = this.props.item;
    const newCost = produce(item.cost, (draft) => {
      _.pullAt(draft[0], ind);
    });
    this.props.handleItemChangeAndBlur(COST, newCost, `cost[0][${ind}].boc`);
  };

  retrieveHeaderGrid = (mode) => {
    let item = this.props.item;
    let headerGrid = 'itemCardContents.headerSection';
    const newlyCreated = _.find(
      _.get(item, 'additionalInformation.changes', []),
      (change) => change.type === 'newlyCreated'
    );

    if (mode === MODES.CLOSEOUT_REPORT || mode === MODES.CLOSEOUT_REPORT_REVIEW) {
      if (newlyCreated) {
        headerGrid = 'itemCardContents.closeoutWriteHeaderSection';
      } else {
        headerGrid = 'itemCardContents.closeoutHeaderSection';
      }
    }
    return headerGrid;
  };

  retrieveFooterGrid = (mode) => {
    let footerGrid = 'itemCardContents.footerSection';
    const isStaffingBundled = this.props.costType === CARD_TYPES.STAFFING_BUNDLED;

    if (mode === MODES.CLOSEOUT_REPORT) {
      footerGrid = 'itemCardContents.closeoutFooterSection';
    } else if (mode === MODES.CLOSEOUT_REPORT_REVIEW) {
      footerGrid = 'itemCardContents.closeoutReviewFooterSectionReadOnly';
      const notFullyInScope = _.get(
        this.props.item,
        ADDITIONAL_INFORMATION + '.' + NOT_FULLY_IN_SCOPE,
        false
      );
      if (notFullyInScope) {
        footerGrid = 'itemCardContents.closeoutReviewFooterSection';
        if (isStaffingBundled) {
          footerGrid = 'itemCardContents.closeoutReviewBundledFooterSection';
        }
      }
    }
    return footerGrid;
  };

  retrieveLayoutGrid = (mode, originalItem) => {
    let closeoutReviewMode = mode === MODES.CLOSEOUT_REPORT_REVIEW;
    let layoutGrid = 'itemCardContents.detailSection.grid';
    if (mode === MODES.CLOSEOUT_REPORT || closeoutReviewMode) {
      layoutGrid = 'itemCardContents.detailSection.closeoutGrid';
      if (!originalItem && !closeoutReviewMode) {
        layoutGrid = 'itemCardContents.detailSection.closeoutNewItemGrid';
      }
    }
    return layoutGrid;
  };

  renderCommonCard = (conf, cost, index, costItemType, costIndex) => {
    const {itemConfig, mode} = this.props;
    const labels = _.get(itemConfig, 'labels');
    const applicationGuidanceLabel = _.get(conf, 'applicationGuidanceLabel');
    const applicationGuidance = _.get(labels, applicationGuidanceLabel, undefined);
    const editable = this.props.editable;
    return (
      <>
        {mode === MODES.APPLICATION && applicationGuidance ? (
          <p>{applicationGuidance}</p>
        ) : null}
        <DynamicElement
          id={this.props.id}
          conf={conf}
          index={index}
          costIndex={costIndex}
          cost={cost}
          costItemType={costItemType}
          handleBlur={this.props.handleBlur}
          handleItemChange={this.props.handleItemChange}
          validationErrors={this.props.validationErrors}
          validationDirtyMap={this.props.validationDirtyMap}
          editable={editable}
        />
      </>
    );
  };

  renderWhole = (costs) => {
    const {itemConfig, editable, mode, originalItem, beingCreated} = this.props;
    const maxCosts = _.get(itemConfig, 'maxCosts');
    const groupByRows = _.chain(
      _.get(itemConfig, this.retrieveLayoutGrid(mode, originalItem))
    )
      .groupBy('rowOrder')
      .map((value, key) => value)
      .value();
    const labels = _.get(itemConfig, 'labels');
    const applicationGuidanceLabel = _.get(
      itemConfig,
      'itemCardContents.detailSection.applicationGuidanceLabel'
    );
    const applicationGuidance = _.get(labels, applicationGuidanceLabel, undefined);
    return (
      costs &&
      _.map(_.take(costs[0], maxCosts), (cost, ind) => {
        return (
          <React.Fragment>
            {this.renderNonCostItemSection(this.retrieveHeaderGrid(mode))}
            {mode === MODES.APPLICATION && applicationGuidance ? (
              <p>{applicationGuidance}</p>
            ) : null}
            {_.map(groupByRows, (data, rowIndex) => {
              return (
                <div key={rowIndex} className="app-form-row margin-bottom-25">
                  {_.map(data, (conf) => {
                    return this.renderCommonCard(
                      conf,
                      cost,
                      ind,
                      COST_ITEM_PERIOD_TYPE.WHOLE
                    );
                  })}
                  {editable && maxCosts && !beingCreated && (
                    <div>
                      {
                        <a
                          id="delete-cost"
                          href="#"
                          onClick={() => this.removeCost(ind)}
                          title={`Click to remove cost`}
                        >
                          <Icon link name="close" color="red" />
                          Remove
                        </a>
                      }
                    </div>
                  )}
                </div>
              );
            })}
            {this.renderNonCostItemSection(this.retrieveFooterGrid(mode))}
          </React.Fragment>
        );
      })
    );
  };

  getCostsTotalQuantity = (costs, attribute = TOTAL) => {
    let total = 0;
    _.map(costs, (costArray, ind) => {
      _.map(costArray, (item) => {
        const value = _.get(item, attribute);
        if (_.isNumber(value)) total = safeAdd(total, value);
      });
    });
    if (total === 0) return '';
    return total;
  };

  getCostsDollarTotal = (costs, totalAttribute) => {
    let total = this.getCostsTotalQuantity(costs, totalAttribute);
    if (_.isNumber(total)) {
      let valueString = total.toString();
      return showDollarAmountWithDollar(valueString);
    }

    return total;
  };

  getCostsYearlyDollarTotal = (costs, totalYears) => {
    let total = this.getCostsTotalQuantity(costs);

    total = safeDivide(total, totalYears);
    if (_.isNumber(total)) {
      let valueString = total.toString();
      return showDollarAmountWithDollar(valueString);
    }

    return total;
  };

  renderNonCostItemSection = (section) => {
    const {itemConfig, item, mode} = this.props;
    const configSection = _.get(itemConfig, section);
    let item2 = this.loadItemWithRefreshedCosts();
    return (
      <React.Fragment>
        {_.map(configSection, (data, rowIndex) => {
          return this.renderCommonCard(data, item2, undefined);
        })}
      </React.Fragment>
    );
  };

  loadItemWithRefreshedCosts = () => {
    const {item: lineItemOrig, mode} = this.props;
    let lineItem = _.cloneDeep(lineItemOrig);
    let closeoutReviewMode = mode === MODES.CLOSEOUT_REPORT_REVIEW;

    const actualTotalPath = `${ADDITIONAL_INFORMATION}.${ACTUAL_TOTAL}`;

    const scopeOfWorkTotalPath = `${ADDITIONAL_INFORMATION}.${SCOPE_OF_WORK_TOTAL}`;
    const allowedExcessTotalPath = `${ADDITIONAL_INFORMATION}.${ALLOWED_EXCESS_TOTAL}`;
    const disallowedTotalPath = `${ADDITIONAL_INFORMATION}.${DISALLOWED_TOTAL}`;
    const categorizedSumPath = `${ADDITIONAL_INFORMATION}.${CATEGORIZED_SUM}`;

    const actualAllowedTotalPath = `${ADDITIONAL_INFORMATION}.${ACTUAL_ALLOWED_TOTAL}`;

    if (closeoutReviewMode) {
      let actualCostArray = _.get(lineItem, actualTotalPath);
      if (actualCostArray && _.size(actualCostArray) > 0) {
        let increments = _.size(actualCostArray);
        let scopeOfWorkTotalArray = _.get(lineItem, scopeOfWorkTotalPath, undefined);
        let allowedExcessTotalArray = _.get(lineItem, allowedExcessTotalPath, undefined);
        let disallowedTotalArray = _.get(lineItem, disallowedTotalPath, undefined);
        let categorizedSumArray = _.get(lineItem, categorizedSumPath, undefined);
        let actualAllowedTotalArray = _.get(lineItem, actualAllowedTotalPath, undefined);
        if (
          !scopeOfWorkTotalArray ||
          !allowedExcessTotalArray ||
          !disallowedTotalArray ||
          !categorizedSumArray ||
          !actualAllowedTotalArray
        ) {
          let path = `${ADDITIONAL_INFORMATION}.${ACTUAL_ALLOWED_TOTAL}`;
          _.set(lineItem, actualAllowedTotalPath, actualCostArray);
          _.set(lineItem, `${actualAllowedTotalPath}Sum`, safeAddReduce(actualCostArray));

          path = `${ADDITIONAL_INFORMATION}.${SCOPE_OF_WORK_TOTAL}`;
          _.set(lineItem, scopeOfWorkTotalPath, actualCostArray);
          _.set(lineItem, `${scopeOfWorkTotalPath}Sum`, safeAddReduce(actualCostArray));

          path = `${ADDITIONAL_INFORMATION}.${CATEGORIZED_SUM}`;
          _.set(lineItem, categorizedSumPath, actualCostArray);
          _.set(lineItem, `${categorizedSumPath}Sum`, safeAddReduce(actualCostArray));

          let zeroArr = new Array(increments).fill(0);
          _.set(lineItem, allowedExcessTotalPath, zeroArr);
          _.set(lineItem, `${allowedExcessTotalPath}Sum`, 0);
          _.set(lineItem, disallowedTotalPath, zeroArr);
          _.set(lineItem, `${disallowedTotalPath}Sum`, 0);
        }
      }
    }
    return lineItem;
  };

  renderYearLineItems = (costs) => {
    const {itemConfig, mode, originalItem, costType} = this.props;

    const isStaffingBundled = costType == CARD_TYPES.STAFFING_BUNDLED;
    const groupByRows = _.chain(
      _.get(itemConfig, this.retrieveLayoutGrid(mode, originalItem))
    )
      .groupBy('rowOrder')
      .map((value, key) => value)
      .value();
    const costsToRender = isStaffingBundled && costs ? [costs[0]] : costs;
    const labels = _.get(itemConfig, 'labels');
    const applicationGuidanceLabel = _.get(
      itemConfig,
      'itemCardContents.detailSection.applicationGuidanceLabel'
    );
    const applicationGuidance = _.get(labels, applicationGuidanceLabel, undefined);
    return (
      <>
        {mode === MODES.APPLICATION && applicationGuidance ? (
          <p>{applicationGuidance}</p>
        ) : null}
        {costsToRender &&
          _.map(costsToRender, (costarray, ind) => {
            let closeoutMode =
              mode === MODES.CLOSEOUT_REPORT || mode === MODES.CLOSEOUT_REPORT_REVIEW;
            let cost = costarray[0];

            return (
              <React.Fragment>
                {_.map(groupByRows, (data, rowIndex) => {
                  return (
                    <div key={rowIndex} className="app-form-row margin-bottom-25">
                      {!isStaffingBundled && (
                        <div className="app-form-block _20">
                          <div className="questionText">
                            {REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[YEAR]}
                          </div>
                          <div style={{textAlign: 'left'}}>{ind + 1}</div>
                        </div>
                      )}
                      {_.map(data, (conf) => {
                        let boc = _.get(conf, BOC);
                        let quantity = _.get(cost, QUANTITY);
                        let actualQuantity = _.get(cost, ACTUAL_QUANTITY);
                        let costIndex = null;
                        if (conf.sum) {
                          cost = {
                            quantity: quantity,
                            price: calculateUnitCosts(costarray),
                          };
                          if (closeoutMode) {
                            cost.actualQuantity = actualQuantity;
                            cost.actualPrice = calculateActualUnitCosts(costarray);
                          }
                        }
                        if (boc) {
                          costIndex = _.findIndex(costarray, (cost) => cost.boc === boc);
                          cost = costarray[costIndex];
                        }
                        return this.renderCommonCard(
                          conf,
                          cost,
                          ind,
                          COST_ITEM_PERIOD_TYPE.YEAR,
                          costIndex
                        );
                      })}
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
      </>
    );
  };

  renderYear = (costs) => {
    const {costType, mode} = this.props;
    const isStaffingBundled = costType == CARD_TYPES.STAFFING_BUNDLED;
    let totalYears = _.size(costs);
    return (
      <React.Fragment>
        {this.renderNonCostItemSection(this.retrieveHeaderGrid(mode))}
        {this.renderYearLineItems(costs)}
        {isStaffingBundled && (
          <div>
            <div className="app-form-row margin-bottom-25">
              <div className="app-form-block _20">{`YEARLY TOTAL`}</div>
              <div className="app-form-block unit_total" style={{textAlign: 'right'}}>
                {costs ? this.getCostsYearlyDollarTotal(costs, totalYears) : null}
              </div>
            </div>
          </div>
        )}
        <div className="app-form-row margin-bottom-25">
          <div className="app-form-block _20">{`${totalYears} YEAR TOTAL`}</div>
          <div className="app-form-block unit_total" style={{textAlign: 'right'}}>
            {costs ? this.getCostsDollarTotal(costs) : null}
          </div>
        </div>
        {this.renderNonCostItemSection(this.retrieveFooterGrid(mode))}
      </React.Fragment>
    );
  };

  renderInternalData(expanded) {
    const {item: lineItem, period, mode} = this.props;
    period.increments = 6;
    let costs = _.get(lineItem, COST);

    let updatedCosts = produce(costs, (draft) => {
      if (draft !== undefined) {
        _.forEach(draft, (cost, index) => {
          if (cost instanceof Array && cost.length > 1) {
            _.forEach(cost, (item, childIdx) => {
              _.set(
                item,
                TOTAL,
                safeMult(_.get(item, PRICE, 0), _.get(item, QUANTITY, 0))
              );
            });
          } else {
            _.set(
              cost,
              [index, TOTAL],
              safeMult(_.get(cost, [index, PRICE], 0), _.get(cost, [index, QUANTITY], 0))
            );
          }
        });
      }
      return draft;
    });

    const renderBasedOnPeriodType = (type, costs) => {
      switch (type) {
        case 'whole':
          return this.renderWhole(costs);
        case 'year':
          return this.renderYear(costs);
        case 'month':
        default:
          return null;
      }
    };

    // render the appropriate widget based on period type, only one period type implemented so far
    return (
      <React.Fragment>
        {renderBasedOnPeriodType(_.lowerCase(period.type), updatedCosts)}
      </React.Fragment>
    );
  }

  isExpanded = () => {
    const {editable, originalItem, mode} = this.props;
    let closeoutMode = mode === MODES.CLOSEOUT_REPORT;
    let closeoutReportMode = mode === MODES.CLOSEOUT_REPORT_REVIEW;

    if (closeoutReportMode) {
      return false;
    }
    return editable && !(closeoutMode && originalItem);
  };

  render() {
    const {
      itemConfig,
      editable,
      beingCreated,
      item: lineItem,
      itemCodeOptions,
      rootPath,
      mode,
    } = this.props;
    let costs = _.get(lineItem, 'cost[0]');
    let maxCosts = _.get(itemConfig, 'maxCosts');

    const itemCode = _.get(lineItem, 'itemCode');
    const itemName = _.get(itemConfig, 'name');

    const reviewOrCloseoutMode =
      mode === MODES.REVIEW ||
      mode === MODES.CLOSEOUT_REPORT ||
      mode === MODES.CLOSEOUT_REPORT_REVIEW;

    var tempItems = itemCodeOptions === undefined ? [] : [...itemCodeOptions];
    var index = _.findIndex(tempItems, function (o) {
      return o.key === String(itemCode);
    });
    const selected = {
      key: String(itemCode),
      value: String(itemCode),
      text: itemName,
    };
    if (index === -1) {
      tempItems.push(selected);
    }

    let expanded = this.isExpanded();

    return (
      <React.Fragment>
        {editable && (
          <HeaderSection
            {...this.props}
            itemCodeOptions={tempItems}
            expanded={expanded}
            handleItemChange={this.props.handleItemChange}
            handleItemChangeAndBlur={this.props.handleItemChangeAndBlur}
          />
        )}
        {this.renderInternalData(expanded)}
        <div className="app-form-row margin-bottom-25">
          {maxCosts &&
            maxCosts > (costs ? _.size(costs) : 1) &&
            editable &&
            !beingCreated && (
              <div>
                {
                  <a
                    id="add-cost"
                    href="#"
                    onClick={this.addCost}
                    title="Click to add an cost"
                  >
                    <Icon link name="add" color="green" />
                    Add cost
                  </a>
                }
              </div>
            )}
        </div>
        {!beingCreated && editable && !reviewOrCloseoutMode && (
          <Grid.Row>
            <Grid.Column width={8}>
              {_.map(_.get(itemConfig, 'additionalQuestions.contents'), (conf, index) => {
                return (
                  <ContentDispatch
                    key={conf.id || index}
                    config={conf}
                    rootPath={rootPath}
                  />
                );
              })}
            </Grid.Column>
          </Grid.Row>
        )}
      </React.Fragment>
    );
  }
}
